<template>
  <router-view></router-view>
</template>

<script lang="ts">
function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  data() {
    return {
      isMobile: isMobileDevice(),
    };
  }
};
</script>
